export default {
  getUserInfo: "https://nuc.api.mgtv.com/GetUserInfo",
  /**阿里云上传预授权 */
  uploadToken: "/xyz/signup/getFileStsToken",
  /**腾讯云cos视频上传预授权 老师发布作品 */
  uploadVideoToken: "/xyz/signup/getVideoStsToken",
  /**获取视频封面 */
  getSnapshot:
    "https://upload-ugc.bz.mgtv.com/upload/thirdpart/video/getSnapshot",

  /**获取报名活动状态*/
  activityState: "/xyz/signup/activityState",
  /**获取报名信息详情 */
  signUpInfo: "/xyz/signup/info",
  /**提交报名信息 */
  signUpSubmit: "/xyz/signup/submit",
  /**视频结果通知 */
  signUpVideoNotify: " /xyz/signup/video/notify",
  /**获取报名信息 */
  getApplyList: "/xyz/signup/list",
  /**退出登录*/
  logout: "https://nuc.api.mgtv.com/Logout",
  /**删除报名信息*/
  deleteSignUp: '/xyz/signup/delete'
};
